import React, { useEffect, useState } from "react";

import { DasboardService } from "../Services/DashboardService";

const TableData = () => {
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [selectedTeamName, setSelectedTeamName] = useState("");


  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  console.log(`role: ${userRole}`);
  const teamName = userData?.teamId || [];
  const [data, setData] = useState({
    siteVisit: { upcoming: 0, completed: 0, noUpdates: 0 },
    booked: { upcoming: 0, completed: 0, noUpdates: 0 },
    registered: { upcoming: 0, completed: 0, noUpdates: 0 },
  });
  const bodTeamId = userData?.teamId?.[0]?.id;

 
  useEffect(() => {
    const fetchData = async (selectedTeamId) => {
      try {
        console.log(`in:${userRole}`);
        const response = await DasboardService.fetchDealForToday(
          userRole,
          selectedTeamId,
          bodTeamId
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData(selectedTeamId);
  }, [selectedTeamId]);
  
  useEffect(() => {
    const storedTeams = userData?.teamId || [];
    setTeams(storedTeams);

    if (userRole === "MD" && storedTeams.length > 0) {
      setSelectedTeamId(storedTeams[0].id);
      setSelectedTeamName(storedTeams[0].name);

    }
  }, [userRole]);

  const handleTeamChange = (event) => {

    teams.forEach((item) =>{
if(item.id ===event.target.value){
  setSelectedTeamName(item.name)
}

    })
    setSelectedTeamId(event.target.value);
    // setSelectedTeamName(event.target.value);
    

    // fetchDealForDayCounts(event.target.value);
  };

  return (
    <>

      {/* <div> */}
      {(userRole === "BOD" || userRole === "MD") && (
        <div className=" h-12 shadow-md rounded-t-md flex mt-10 items-center justify-between px-4 bg-white">
          {userRole === "BOD" && (
            <div className="text-black text-lg font-bold">
              Team:
              <span className="text-customGreen font-normal">
                {teamName[0].name}{" "}
              </span>
            </div>
          )}
          {userRole === "MD" && (
            <div className="text-black text-lg font-bold">
              Team:
              <span className="text-customGreen font-normal">
                {selectedTeamName}{" "}
              </span>
            </div>
          )}

          {userRole === "MD" && (
            <select
              id="teamSelect"
              value={selectedTeamId}
              onChange={handleTeamChange}
              className=" block w-56 h-8 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"

              // className=" block w-20 h-8 py-2 px-3  bg-white   text-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {teams.map((team) => (
                <option key={team.id} value={team.id}>
                  {team.name}
                </option>
              ))}
            </select>
          )}
        </div>
      )}
      {/* </div> */}

      <table className="  shadow-md w-full xl:text-lg custom-xl:text-xl 3xl:text-2xl 4xl:text-3xl rounded-lg text-center   bg-white border-collapse lg:text-sm">
        <thead>
          <tr className="whitespace-nowrap">
            <th className="border-r-2 border-t-2 border-slate-400 p-4 bg-customGreen text-white">
              Today
            </th>
            <th className="border-r-2 border-t-2 border-slate-400 p-4">
              Site Visit
            </th>
            <th className="border-r-2 border-t-2 border-slate-400 p-4">
              Booking
            </th>
            <th className="border-t-2 border-slate-400 p-4">Registration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className=" border-t-2 border-r-2 border-slate-400 p-4">
              Upcoming
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.upcoming ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.upcoming ?? 0}
            </td>
            <td className="border-t-2 border-slate-400 p-4">
              {data.registered?.upcoming ?? 0}
            </td>
          </tr>
          <tr>
            <td className=" border-t-2 border-r-2 border-slate-400 p-4">
              Completed
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.completed ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.completed ?? 0}
            </td>
            <td className="border-t-2  border-slate-400 p-4">
              {data.registered?.completed ?? 0}
            </td>
          </tr>
          <tr>
            <td className="border-t-2 border-r-2 border-slate-400 p-4 text-red-600">
              No update
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.siteVisit?.noUpdates ?? 0}
            </td>
            <td className="border-t-2 border-r-2 border-slate-400 p-4">
              {data.booked?.noUpdates ?? 0}
            </td>
            <td className="border-t-2  border-slate-400 p-4">
              {data.registered?.noUpdates ?? 0}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default TableData;
